import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockLineStringGeometry,
    LineStringGeometry,
    lineStringGeometrySchema,
} from 'app/agriculture/queries/types/geometry/LineStringGeometry';

export interface Waterway extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;

    geometry: LineStringGeometry;
}

export const waterwaySchema = mapEntitySchema.extend({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),

    geometry: lineStringGeometrySchema,
});

export const mockWaterway = ({
    id = 'be20bd4d-dbd5-415d-88f6-0e8f0ad91020',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Waterway Name',

    geometry = mockLineStringGeometry(),
}: Partial<Waterway> = {}): Waterway => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,

    geometry,
});
